import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Styles/Timeline.css";
import LayOut from "../components/LayOut";

const services = [
  {
    title: "Web Application Development",
    description:
      "We build scalable and robust web applications tailored to your needs.",
    icon: "🌐",
  },
  {
    title: "DotNet Core API Development",
    description:
      "Create API which are used in mobile Application like React Native Developement",
    icon: "📱",
  },
  {
    title: "Backend Development",
    description:
      "Secure and efficient backend solutions for your applications.",
    icon: "💻",
  },
];

const Services = () => {
  return (
    <LayOut title={"Services"}>
      <div className="container my-5">
        <h2 className="text-center text-white mb-4">Our Services</h2>
        <div className="row">
          {services.map((service, index) => (
            <div key={index} className="col-md-4">
              <div className="service-card p-4 text-center">
                <div className="service-icon">{service.icon}</div>
                <h3 className="mt-3">{service.title}</h3>
                <p>{service.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </LayOut>
  );
};

export default Services;
